export default "__VITE_ASSET__ChRy1msb__"